import { SectionBenefits } from '@sbercloud/uikit-product-site-section';
import { useRouter } from 'next/navigation';
import React from 'react';
import { useAnalytics } from 'src/hooks/useAnalytics';

import { useLayoutType } from '../../hooks/useLayoutType';
import { DocumentationProps, Grid } from './types';
import { getColumnsConfig } from './utils';

export function Documentation({
  id,
  title,
  description,
  cards,
  grid = Grid.TwoColumns,
}: DocumentationProps) {
  const layoutType = useLayoutType();
  const router = useRouter();
  const { clickAnalytics } = useAnalytics();

  return (
    <SectionBenefits
      id={id}
      title={title}
      description={description}
      columnsConfig={getColumnsConfig(grid)}
      layoutType={layoutType}
      type="info"
      content={cards.map(({ title, slug, text, target = '_self' }) => ({
        title,
        description: text,
        target,
        href: slug,
        onClick(e) {
          if (target !== '_blank') {
            e?.preventDefault();
            router.push(slug);
          }

          clickAnalytics({
            action: slug,
            clickZone: 'body',
            clickElement: 'cardclick',
            clickContent: title,
            uniqueId: `documentation-card-${title}`,
            transitionType: 'inside-link',
            clickZoneCategory: 'site-body',
            transitionUrl: slug,
            transitionTypeMetrics: 'internal',
          });
        },
      }))}
    />
  );
}
